import { Alert, Button, TextField } from "@mui/material";
import Typography from "@mui/material/Typography/Typography";
import React from "react";
import { NotrufResponseNumber } from "../utils/WhatsAppBot";
import { Backend } from "../utils/Backend";
import { NotrufList, TabEnum } from "../App";

export default function ViaRufnummer({changeTab}: {changeTab: (tab: number) => void}) {

    const [value, setValue] = React.useState("");
    const [answer, setAnswer] = React.useState<NotrufResponseNumber>();
    const [error, setError] = React.useState(false);

    const send = (value: string) => {
        value = value.trim();
        if (value === "") return;
        Backend.sendRequest("GET", "/bynumber?number=" + value)
            .then((response: NotrufResponseNumber) => {
                setAnswer(response);

                if (response.state === 'OK') setValue("");
                setError(false);
            }).catch(() => {
                setError(true);
            });
    };
    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginBottom: 15 }}>
                <Typography>
                    Bitte geben Sie Ihre Rufnummer an, damit wir Sie Ihrem Objekt zuordnen können.
                </Typography>
            </div>

            <TextField variant="outlined" fullWidth label="Nummer" value={value} onKeyDown={(e) => {
                if (e.key === "Enter") {
                    send(value);
                }
            }} onChange={e => setValue(e.target.value)}
                InputProps={{
                    inputMode: "tel",
                    endAdornment: <Button onClick={() => send(value)} disabled={value.trim() === ""}>
                        Senden
                    </Button>
                }}
            />

            {error && <Alert severity='error'>Unsere Server werden gerade gewartet. Bitte probieren Sie es in wenigen Minuten erneut.</Alert>}

            {answer && <div>
                <div style={{ marginTop: 15 }} />
                {answer.state === "NOT_A_NUMBER" &&
                    <Alert severity='error'>
                        Die eingegebene Rufnummer ist ungültig. Bitte überprüfen Sie Ihre Eingabe.
                    </Alert>
                }
                {answer.state === "UNKNOWN_USER" &&
                    <Alert severity='warning'>
                        Sehr geehrte Eigentümer:innen,<br /> sehr geehrte Kund:innen,<br />
                        <br />
                        leider konnten wir Ihre Rufnummer in unserem System nicht zuordnen.
                        Bitte versuchen Sie sich über Ihre Adresse zu verifizieren. Klicken Sie dazu auf den Reiter <Button onClick={(e) => {
                            e.preventDefault();
                            changeTab(TabEnum.ViaAdresse);
                        }}>Via Adresse</Button> und geben Sie Ihre Adresse ein.
                        <br/>
                        <br/>
                        Haben sich Ihre bei uns hinterlegten persönlichen Daten geändert?<br />

                        Dann teilen Sie uns dies bitte unter Angabe<br />

                        - Ihres vollständigen Namens<br />
                        - Ihrer Objektadresse<br />

                        unter <a href="mailto:info@icvg.de">info@icvg.de</a> mit.<br />
                    </Alert>
                }
                {answer.state === "OK" && <div>
                    Wir haben für Ihre Rufnummer {answer.number} die folgenden Objekte gefunden:
                    <NotrufList entries={answer.objs} />
                </div>}
            </div>}
    </>
    )
};